













import { Component, Prop, Mixins } from 'vue-property-decorator';
import GoogleMapsMixin from '@/mixins/googleMapsMixin';
import { LINK_TYPES } from '@/models/enums/link-type';

type LinkAttributes = { [key: string]: string | { [key: string]: string } };
@Component({
  name: 'link-widget',
})
export default class LinkWidget extends Mixins(GoogleMapsMixin) {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Number, default: LINK_TYPES.STANDARD }) type!: LINK_TYPES;
  @Prop({ type: [String, Object], required: true }) to!:
    | string
    | { [key: string]: string };

  private url: string | { [key: string]: string } | null = null;

  private get isExternal(): boolean {
    return typeof this.to === 'string';
  }

  private get linkType(): string {
    return this.isExternal ? 'a' : 'router-link';
  }

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }

  private get attrs(): LinkAttributes {
    return this.isExternal
      ? {
          href: this.url as string,
          target: '_blank',
        }
      : {
          to: this.url as { [key: string]: string },
        };
  }

  async created() {
    if (this.type == LINK_TYPES.GO_TO_MAPS) {
      this.url = await this.getMapUrl();
    } else {
      this.url = this.to as string;
    }
  }
}
